import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import RedLogo from "../layout/Mentors/RedLogo";

const SetupMentor = ({ auth: { user, isAuthenticated } }) => {
  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <div className="setup-container">
        <div className="initialize-title red">
          <div className="flex">
            <div className="logo-setup">
              <RedLogo />
            </div>
            <h1 class="setup-heading red">
              Welcome to ime, {user && user.firstname}!
            </h1>
          </div>
          <p class="lead">Create your first course!</p>
        </div>
        <div class="setup-container">
          <div class="section-info">
            <p class="setup-info">See information below:</p>
          </div>
        </div>
        <section class="information">
          <p class="info-message red">Thank you for your commitment</p>
          <p class="info-description">
            Dear {user.firstname} {user.lastname},
            <br /> You've officially taken the first step in becoming a Mentor
            in the incredible world of ime! This means that you are as motivated
            and dedicated as we are, in terms of developing the world we live in
            by sharing your knowledge and skills with individuals inspired by
            leaders such as yourself! The next step is to create at least one
            course before you begin to gain your following and interact with
            users. Once your course is submitted and approved, we will notify
            you and you will be on your way!
          </p>
          <Link to={`/${user.channelid}/create_course`}>
            <p class="info-message red cursor">
              Create your course now!
              <i class="fas fa-arrow-circle-right red mx-5"></i>
            </p>
          </Link>
        </section>
      </div>
    </Fragment>
  );
};

SetupMentor.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SetupMentor);
